import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";

const POModal = ({ showModal, closeModal, branch, poNo, onSelectItem }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [allSuppliers, setAllSuppliers] = useState([]);
  const [filteredSuppliers, setFilteredSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (showModal) {
      fetchSuppliers();
    }
  }, [showModal]);

  const fetchSuppliers = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/purchaseOrder_schedule", {
        params: { branchcode: branch,
            poNo : poNo,
         },
      });
      setAllSuppliers(response.data);
      setFilteredSuppliers(response.data); 
    } catch (error) {
      console.error("Error fetching suppliers:", error);
    }
    setLoading(false);
  };


  const handleSelectItem = (item) => {
    onSelectItem(item);
    closeModal();
  };

  if (!showModal) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <h3 className="modal-title">Schedule Details</h3>

        

        <div className="search-results">
          <table>
            <thead>
              <tr>
                <th>Schedule No</th>
                <th>ItemCode</th>
                <th>Schedule Date</th>
                <th>Schedule Qty</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5" className="loading-text">Loading...</td>
                </tr>
              ) : filteredSuppliers.length > 0 ? (
                filteredSuppliers.map((item) => (
                  <tr key={item.prdetail_suppliercode}>
                    <td>{item.PurchaseOrderSchedule_SerialNumber}</td>
                    <td>{item.PurchaseOrderSchedule_ItemCode}</td>
                    <td>{new Date(item.PurchaseOrderSchedule_Date).toLocaleDateString()}</td>
                    <td>{item.PurchaseOrderSchedule_Quantity}</td>
                  
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">No results found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <button className="close-btn" onClick={closeModal}>Close</button>
      </div>
    </div>
  );
};

export default POModal;
